import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { Dispatch } from './Dispatch';

// G-OD1: Ezy › Dịch vụ › Điều phối hiện trường (Mint-OpsDispatch) — /ezy/service/dispatch. Không thêm mục menu riêng (vào từ Service Hub).
const dispatch: EzyModule = {
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/service/dispatch', component: Dispatch })],
};
export default dispatch;
